var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscribersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.243 5.85448L9.49 0.310478C9.64542 0.217227 9.82325 0.167969 10.0045 0.167969C10.1857 0.167969 10.3636 0.217227 10.519 0.310478L19.757 5.85548C19.8311 5.89989 19.8925 5.96276 19.9351 6.03794C19.9776 6.11313 20 6.19807 20 6.28448V19.0005C20 19.2657 19.8946 19.5201 19.7071 19.7076C19.5196 19.8951 19.2652 20.0005 19 20.0005H1C0.734784 20.0005 0.48043 19.8951 0.292893 19.7076C0.105357 19.5201 1.10073e-08 19.2657 1.10073e-08 19.0005V6.28348C-1.81179e-05 6.19707 0.0223578 6.11213 0.0649455 6.03694C0.107533 5.96176 0.168879 5.89889 0.243 5.85448ZM16.346 7.24448L10.061 12.6835L3.647 7.23848L2.353 8.76248L10.073 15.3175L17.654 8.75748L16.346 7.24448Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscribersIcon);
export default __webpack_public_path__ + "static/media/subscribers_icon.573c0d33a15a519f0318b13edf382e04.svg";
export { ForwardRef as ReactComponent };